import React, { FC } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import OverlayCarouselPopup from '../@shared/overlayCarouselPopup';
import { MediaGalleryModel } from './models/mediaGallery.model';
import { TMediaGalleryProps } from './types/mediaGallery.types';
import Heading from '../@shared/heading';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import UnreleasedComponent from '../@shared/unreleasedComponent';

const MediaGallery: FC<TMediaGalleryProps> = (props) => {
  const isEE = props?.sitecoreContext?.pageEditing;
  const model = new MediaGalleryModel(props);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <AnalyticsVisibleEvent rendering={props?.rendering} title={model.title?.value} template="Media Gallery">
      <section className="media-gallery">
        <div className="media-gallery__content">
          <Heading
            eyebrow={model.eyebrow}
            title={model.title}
            subtitle={model.description}
            hideSecondaryLink={true}
            customTextTitle
            customTextSubtitle
            editable={true}
            tag={model.headingTag}
          />
        </div>
        {model.slides && (
          <OverlayCarouselPopup
            slides={model.slides}
            isEE={isEE}
            showNavDeck={true}
            showOverlayTitleAndDescription={true}
            editorial={true}
            richTextTitle={true}
            richTextDescription={true}
            useAnalytics
            useAnalyticsVisibleEvent={false}
          />
        )}
      </section>
    </AnalyticsVisibleEvent>
  );
};

export default withSitecoreContext()(MediaGallery);
